/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { getTelemetryObject, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';

import { Link } from './components/link';

import { IEcommJobCardViewProps } from './ecomm-job-card';

/**
 *
 * EcommContentTemplate1View component
 * @extends {React.PureComponent<IEcommJobCardViewProps>}
 */
 export class EcommJobCardView extends React.PureComponent<IEcommJobCardViewProps> {
  private telemetryContent: ITelemetryContent = getTelemetryObject(this.props.context.request.telemetryPageName!,
    this.props.friendlyName, this.props.telemetry);

  public render(): JSX.Element | null {
    const { description, config } = this.props;

    return (
      <div className='ecomm-job-card'>
        <h4 className='ecomm-job-card-title'>{config.title}</h4>
        <div className='row ecomm-job-card-content'>
          <div className='col-sm-8 ecomm-job-card-text'>
            <p id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>{description}</p>
          </div>
          <div className='col-sm-4 ecomm-job-card-action'>
            <Link
              className='ecomm-job-card-nav'
              text={config.link?.linkText}
              context={this.props.context}
              ariaLabel={config.link?.ariaLabel || config.link?.linkText}
              href={config.link?.linkUrl && config.link.linkUrl.destinationUrl}
              telemetryContent={this.telemetryContent}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default EcommJobCardView;